import React from 'react'

interface StarIconProps {
    filled?: boolean
    size?: number
    color?: string
    outlineColor?: string
    onClick?: (e: React.MouseEvent) => void
}

const StarIcon: React.FC<StarIconProps> = ({
    filled = false,
    size = 20,
    color = '#3452FF',
    outlineColor = '#D6D6D6',
    onClick,
}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={{ cursor: onClick ? 'pointer' : 'default', flexShrink: 0 }}
        >
            <path
                d="M10 1.5L12.472 6.511L18 7.327L14 11.22L14.944 16.727L10 14.127L5.056 16.727L6 11.22L2 7.327L7.528 6.511L10 1.5Z"
                fill={filled ? color : 'none'}
                stroke={filled ? color : outlineColor}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default StarIcon
export type { StarIconProps }
